module.exports = __webpack_public_path__ + "img/4.8b767964.png";